import { getSupabaseOrThrow } from '../supabaseClient'

function normalizeEmail(email: string): string {
  return email.trim().toLowerCase()
}

export async function subscribeToWaitlist(input: { email: string; source?: string }): Promise<void> {
  const supabase = getSupabaseOrThrow()
  const email = normalizeEmail(input.email)
  if (!email) throw new Error('Podaj email.')

  const { error } = await supabase.from('waitlist_signups').insert({
    email,
    source: input.source ?? 'register',
  })

  if (error) {
    const details = import.meta.env.DEV ? ` (${error.message})` : ''
    throw new Error(`Nie udało się zapisać maila. Spróbuj ponownie później.${details}`)
  }
}

